import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mwp-placeholder-table',
    templateUrl: './table.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PlaceHoldertableComponent {
    @Input() public displayButton: boolean;
    public cssClassWave: string = 'placeholder-wave';
    public cssClassGlow: string = 'placeholder-glow';
}